import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Drawer from "@material-ui/core/Drawer";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import ReactPhoneInput from "react-phone-input-2";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import DialogTitle from "@material-ui/core/DialogTitle";
import { withSnackbar } from "notistack";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import React from "react";
import { ResponsiveBarCanvas } from "@nivo/bar";
import { ResponsiveLineCanvas } from "@nivo/line";
import { shortmonths, getFormattedImageLink, getFormattedDate } from "Utils";
import defaultstateimg from "Assets/Svg/group-5.svg";
import DefaultComp from "Component/DefaultComp/Defaultstatecomp";
import ShareIdea from "./ShareIdea";
import { instance } from "Actions/AxiosInstance";
import TextField from "Component/Material-ui/TextField";
import DynamicForm from "Component/DynamicForm";
import celebration from "Assets/Icons/Celebrate/celebrate-16px.svg";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import {
  employeeCountTypes,
  requestCountTypes,
  filterTypes,
  subfilterTypes,
} from "Module/Subscription/Dashboard/constants";
import { multiselectinputconverter } from "Component/DynamicForm/Fields/MultiSelect";
import LabelIcon from "Component/Labels/LabelIcon";
import DrawerHeader from "Component/Headers/drawerHeader";
import user from "Assets/Icons/User/user-16px.svg";
import rightarrow from "Assets/Svg/right-arrow-blue.svg";
import TabContainer from "Component/Common/TabContainer";
import invite from "Assets/Svg/invite.svg";
import check from "Assets/Svg/check.svg";
import "./index.css";
import get from "lodash/get";

class Hris extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      upcomingEvents: [],
      employeecounttype: 1,
      employeeCountData: [],
      requestcounttype: 6,
      requestCountData: [],
      hefiltertypeid: 1,
      hesubfiltertypeid: 1,
      hesubfilterids: [],
      afiltertypeid: 1,
      asubfiltertypeid: 1,
      asubfilterids: [],
      hireexitdata: [],
      attrition: [],
      joining: 0,
      recentJoinees: [],
      DrawerOpen: false,
      empdata: [
        {
          firstname: "",
          middlename: null,
          lastname: "",
          emailid: "",
          primarymobile: "",
          callingcode: "",
          mobile: "",
          isEmailtrue: false,
        },
        {
          firstname: "",
          middlename: null,
          lastname: "",
          emailid: "",
          primarymobile: "",
          callingcode: "",
          mobile: "",
          isEmailtrue: false,
        },
        {
          firstname: "",
          middlename: null,
          lastname: "",
          emailid: "",
          primarymobile: "",
          callingcode: "",
          mobile: "",
          isEmailtrue: false,
        },
      ],
      open: false,
      value: 0,
      invited0: false,
      invited1: false,
    };

    this.selectFilter = this.selectFilter.bind(this);
    this.openDrawer = this.openDrawer.bind(this);
    this.handleClickAway = this.handleClickAway.bind(this);
    this.openDilogGrid = this.openDilogGrid.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.OnPhoneChange = this.OnPhoneChange.bind(this);
    this.sendDetails = this.sendDetails.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.validateEmail = this.validateEmail.bind(this);
    this.setTabValue = this.setTabValue.bind(this);
  }

  componentDidMount() {
    this.getEmployeeCount();
    this.getHireAndExits();
    this.getAttrition();
    this.getRequest();
    this.getUpcomingEvent();
    this.getJoineeAndExitCount();
  }

  getJoineeAndExitCount() {
    const data = {
      lastdays: 7,
    };
    instance
      .post("hrisdashboard/joiningandexitcount", data)
      .then((result) => {
        this.setState({
          joining: result.data.result[0].joining,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getUpcomingEvent() {
    instance
      .post("hrisdashboard/upcomingevent")
      .then((result) => {
        const upcomingEvents = [
          ...(result.data.result[0].birthday
            && result.data.result[0].birthday.map((hol) => ({
              ...hol,
              birthday: true,
              work: false,
              mrg: false,
            }))),
          ...(result.data.result[0].workanniversary
            && result.data.result[0].workanniversary.map((hol) => ({
              ...hol,
              birthday: false,
              work: true,
              mrg: false,
            }))),
          ...(result.data.result[0].marriageanniversary
            && result.data.result[0].marriageanniversary.map((hol) => ({
              ...hol,
              birthday: false,
              work: false,
              mrg: true,
            }))),
        ];

        this.setState({
          upcomingEvents,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  openDrawer() {
    this.setState(
      {
        DrawerOpen: true,
      },
      () => {
        this.getRecentJoinees();
      },
    );
  }

  handleClickAway() {
    this.setState({
      DrawerOpen: false,
    });
  }

  getRecentJoinees() {
    const data = {
      isjoining: true,
      isexits: false,
      lastdays: 7,
      offset: this.state.offset,
      limit: this.state.limit,
    };
    instance
      .post("hrisdashboard/joiningandexitemployeelist", data)
      .then((result) => {
        const recentJoinees = [
          ...(result.data.result[0].joining && result.data.result[0].joining),
        ];
        this.setState({
          recentJoinees,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  openDilogGrid() {
    this.setState({
      open: true,
    });
  }

  handleClose() {
    this.setState({
      open: false,
    });
  }

  getEmployeeCount() {
    instance
      .post("hrisdashboard/employeecount", {
        filtertypeid: this.state.employeecounttype,
      })
      .then((result) => {
        this.setState({
          employeeCountData: result.data.result,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getHireAndExits() {
    instance
      .post("hrisdashboard/joinvsexits", {
        filtertypeid: this.state.hefiltertypeid,
        subfiltertypeid: this.state.hesubfiltertypeid,
        subfilterids:
          this.state.hesubfilterids && this.state.hesubfilterids.length > 0
            ? this.state.hesubfilterids.join(",")
            : null,
      })
      .then((result) => {
        const joindata = result.data.result[0]
          ? result.data.result[0].joinvsexits.map((j) => ({
              x:
                this.state.hefiltertypeid != 5
                  ? shortmonths.find((m) => m.id == j.displayid)
                    ? shortmonths.find((m) => m.id == j.displayid).name
                    : ""
                  : j.displayid,
              y: j.join,
            }))
          : [];
        const exitdata = result.data.result[0]
          ? result.data.result[0].joinvsexits.map((j) => ({
              x:
                this.state.hefiltertypeid != 5
                  ? shortmonths.find((m) => m.id == j.displayid)
                    ? shortmonths.find((m) => m.id == j.displayid).name
                    : ""
                  : j.displayid,
              y: j.exit,
            }))
          : [];
        const data = [
          {
            id: "Hires",
            data: joindata,
          },
          {
            id: "Exits",
            data: exitdata,
          },
        ];
        this.setState({
          hireexitdata: data,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getAttrition() {
    instance
      .post("hrisdashboard/attritionper", {
        filtertypeid: this.state.afiltertypeid,
        subfiltertypeid: this.state.asubfiltertypeid,
        subfilterids:
          this.state.asubfilterids && this.state.asubfilterids.length > 0
            ? this.state.asubfilterids.join(",")
            : null,
      })
      .then((result) => {
        const attdata = result.data.result[0]
          ? result.data.result[0].attrition.map((j) => ({
              x:
                this.state.afiltertypeid != 5
                  ? shortmonths.find((m) => m.id == j.displayid)
                    ? shortmonths.find((m) => m.id == j.displayid).name
                    : ""
                  : j.displayid,
              y: parseFloat(j.attper).toFixed(2),
            }))
          : [];
        const data = [
          {
            id: "Attrition",
            data: attdata,
          },
        ];
        this.setState({
          attrition: data,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getRequest() {
    instance
      .post("hrisdashboard/requestcount", {
        filtertypeid: this.state.requestcounttype,
      })
      .then((result) => {
        const data = [
          {
            reqdata: [],
            totalrequestcount: result.data.result[0]
              ? result.data.result[0].reqdata[0].totalrequestcount
              : 0,
          },
        ];
        result.data.result[0]
          && result.data.result[0].reqdata.forEach((d) => {
            if (d.autorequest) {
              data[0].reqdata.push({
                displayname: Object.keys(d.autorequest)[0],
                displayvalue: d.autorequest[Object.keys(d.autorequest)[0]],
              });
            }
            if (d.employeerequest) {
              data[0].reqdata.push({
                displayname: Object.keys(d.employeerequest)[0],
                displayvalue:
                  d.employeerequest[Object.keys(d.employeerequest)[0]],
              });
            }
            if (d.attendancerequest) {
              data[0].reqdata.push({
                displayname: Object.keys(d.attendancerequest)[0],
                displayvalue:
                  d.attendancerequest[Object.keys(d.attendancerequest)[0]],
              });
            }
            if (d.leaverequest) {
              data[0].reqdata.push({
                displayname: Object.keys(d.leaverequest)[0],
                displayvalue: d.leaverequest[Object.keys(d.leaverequest)[0]],
              });
            }
            if (d.expenserequest) {
              data[0].reqdata.push({
                displayname: Object.keys(d.expenserequest)[0],
                displayvalue:
                  d.expenserequest[Object.keys(d.expenserequest)[0]],
              });
            }
            if (d.hrletterrequest) {
              data[0].reqdata.push({
                displayname: Object.keys(d.hrletterrequest)[0],
                displayvalue:
                  d.hrletterrequest[Object.keys(d.hrletterrequest)[0]],
              });
            }
            if (d.payrollrequest) {
              data[0].reqdata.push({
                displayname: Object.keys(d.payrollrequest)[0],
                displayvalue:
                  d.payrollrequest[Object.keys(d.payrollrequest)[0]],
              });
            }
          });
        this.setState({
          requestCountData: data,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  selectFilter(val, key) {
    this.setState(
      {
        [key]: val,
      },
      () => {
        if (key == "employeecounttype") {
          this.getEmployeeCount();
        } else if (key == "requestcounttype") {
          this.getRequest();
        } else if (key == "hefiltertypeid") {
          this.getHireAndExits();
        } else if (key == "hesubfiltertypeid" && val == 1) {
          this.getHireAndExits();
        } else if (key == "hesubfilterids") {
          this.getHireAndExits();
        } else if (key == "afiltertypeid") {
          this.getAttrition();
        } else if (key == "asubfiltertypeid" && val == 1) {
          this.getAttrition();
        } else if (key == "asubfilterids") {
          this.getAttrition();
        }
      },
    );
  }

  OnTabChange = (event, value) => {
    this.setState({ value });
  };

  setTabValue(value) {
    this.setState({ value });
  }

  OnPhoneChange(index, field, value) {
    const { empdata } = this.state;
    if (empdata[index]) {
      empdata[index].callingcode = value.dialCode;
      empdata[index].mobile = field;
    }
    field = field.replace(/[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g, "");
    const no = field.replace(value.dialCode, "");
    const x = no.trim();
    empdata[index].primarymobile = x;
    this.setState({ empdata });
  }

  handleChange(name, e, index) {
    const { empdata } = this.state;
    empdata[index][name] = e;
    this.setState({
      empdata,
    });
  }

  validateEmail(value, index) {
    const { empdata } = this.state;
    const currentemail = value;
    if (currentemail != "") {
      if (
        /^\w+([\.-]?\w+)*([+]{0,1}\w+){0,1}@\w+([\.-]?\w+)*(\.\w{2,15})+$/.test(
          currentemail,
        )
      ) {
        const x = empdata.find(
          (email, index1) => index != index1 && email.emailid == currentemail,
        );
        if (x) {
          this.props.enqueueSnackbar("Please enter unique email ID", {
            variant: "error",
          });
          empdata[index].isEmailtrue = false;
        } else {
          empdata[index].isEmailtrue = true;
        }
        this.setState({ empdata });
      } else {
        empdata[index].isEmailtrue = false;
        this.setState({ empdata });
        this.props.enqueueSnackbar("Please enter valid email ID", {
          variant: "error",
        });
      }
    } else {
      this.props.enqueueSnackbar("Please fill all the required fileds", {
        variant: "error",
      });
    }
  }

  sendDetails() {
    const employeedetails = [];
    if (this.state.value == 0) {
      this.state.empdata.forEach((item) => {
        if (item.firstname && item.lastname && item.isEmailtrue) {
          const object = {
            firstname: item.firstname,
            lastname: item.lastname,
            middlename: null,
            primarymobile: item.primarymobile,
            callingcode: item.callingcode,
            emailid: item.emailid,
          };
          employeedetails.push(object);
        }
      });
    } else {
      this.state.empdata.forEach((item) => {
        if (item.firstname && item.lastname && item.primarymobile) {
          const object = {
            firstname: item.firstname,
            lastname: item.lastname,
            middlename: null,
            primarymobile: item.primarymobile,
            callingcode: item.callingcode,
            emailid: item.emailid,
          };
          employeedetails.push(object);
        }
      });
    }

    const data = {
      employeedata: employeedetails,
      issms: this.state.value == 0 ? false : true,
    };
    console.log("data: ", data);
    const URL = `account/prospectemployee/${get(
      this.props,
      "AuthenticationAction.login.subscriptionid",
      "",
    )}`;

    if (employeedetails.length > 0) {
      instance
        .post(URL, data)
        .then(() => {
          this.props.enqueueSnackbar("Invite Sent Succesfully", {
            variant: "success",
          });
          if (this.state.value == 1) {
            this.setState({
              invited1: true,
              empdata: [
                {
                  firstname: "",
                  middlename: null,
                  lastname: "",
                  emailid: "",
                  primarymobile: "",
                  callingcode: "",
                  mobile: "",
                  isEmailtrue: false,
                },
                {
                  firstname: "",
                  middlename: null,
                  lastname: "",
                  emailid: "",
                  primarymobile: "",
                  callingcode: "",
                  mobile: "",
                  isEmailtrue: false,
                },
                {
                  firstname: "",
                  middlename: null,
                  lastname: "",
                  emailid: "",
                  primarymobile: "",
                  callingcode: "",
                  mobile: "",
                  isEmailtrue: false,
                },
              ],
            });
          } else {
            this.setState({
              invited0: true,
              empdata: [
                {
                  firstname: "",
                  middlename: null,
                  lastname: "",
                  emailid: "",
                  primarymobile: "",
                  callingcode: "",
                  mobile: "",
                  isEmailtrue: false,
                },
                {
                  firstname: "",
                  middlename: null,
                  lastname: "",
                  emailid: "",
                  primarymobile: "",
                  callingcode: "",
                  mobile: "",
                  isEmailtrue: false,
                },
                {
                  firstname: "",
                  middlename: null,
                  lastname: "",
                  emailid: "",
                  primarymobile: "",
                  callingcode: "",
                  mobile: "",
                  isEmailtrue: false,
                },
              ],
            });
          }
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    } else {
      this.props.enqueueSnackbar("Please fill all the required fileds", {
        variant: "error",
      });
    }
  }

  render() {
    const {
      employeecounttype,
      requestcounttype,
      hefiltertypeid,
      hesubfiltertypeid,
      hesubfilterids,
      afiltertypeid,
      asubfilterids,
      asubfiltertypeid,
    } = this.state;
    const { value, invited0, invited1 } = this.state;
    return (
      <Grid container spacing={1}>
        <Grid item xs={12} md={12} sm={12}>
          <Paper className="padding16 margin-bottom-16 rounded-rectangle-paper">
            <div className="t-bold margin-bottom-8">Employee count</div>
            <div className="width30">
              <DynamicForm
                fields={selectinputconverter({
                  value: employeecounttype,
                  label: "",
                  options: employeeCountTypes,
                  disabled: false,
                })}
                onChange={(val) => this.selectFilter(val, "employeecounttype")}
              />
            </div>
            <div style={{ height: 300 }}>
              <ResponsiveBarCanvas
                height={300}
                layout="vertical"
                data={
                  this.state.employeeCountData[0]
                    ? this.state.employeeCountData[0].empdata.map((x) => ({
                        Value: x.displayvalue,
                        displayname: x.displayname.substring(0, 12),
                      }))
                    : []
                }
                keys={["Value"]}
                indexBy={"displayname"}
                pixelRatio={1}
                padding={0.8}
                margin={{
                  top: 10,
                  right: 10,
                  bottom: 80,
                  left: 30,
                }}
                minValue="0"
                maxValue={
                  Math.max(
                    ...(this.state.employeeCountData[0]
                      ? this.state.employeeCountData[0].empdata.map(
                          (x) => x.displayvalue,
                        )
                      : []),
                  ) || "auto"
                }
                colors={["#0095ff"]}
                enableLabel={true}
                axisRight={null}
                axisLeft={{
                  tickSize: 5,
                  tickPadding: 5,
                  tickRotation: 0,
                  legend: "Value",
                  legendPosition: "middle",
                  legendOffset: -100,
                }}
                axisBottom={{
                  tickSize: 3,
                  tickPadding: 2,
                  tickRotation: -90,
                  legend: "",
                  tickValues:
                    Math.max(
                      ...(this.state.employeeCountData[0]
                        ? this.state.employeeCountData[0].empdata.map(
                            (x) => x.displayvalue,
                          )
                        : []),
                    ) > 2
                      ? 4
                      : 2,
                  legendPosition: "middle",
                  legendOffset: -160,
                }}
                enableGridX={true}
                enableGridY={true}
                animate={true}
                motionStiffness={90}
                motionDamping={15}
                isInteractive={true}
                labelSkipHeight={20}
              />
            </div>
          </Paper>
        </Grid>
        <Grid item xs={12} md={12} sm={12}>
          <Paper className="padding16 margin-bottom-16 rounded-rectangle-paper">
            <Grid container spacing={1}>
              <Grid item xs={12} md={2} sm={12}>
                <div className="t-bold margin-bottom-8">Hires and exits</div>
              </Grid>
              <Grid item xs={12} md={10} sm={12}>
                <div
                  className="width100"
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <div className="width30 margin-right-8">
                    <DynamicForm
                      fields={selectinputconverter({
                        value: hefiltertypeid,
                        label: "",
                        options: filterTypes,
                        disabled: false,
                      })}
                      onChange={(val) =>
                        this.selectFilter(val, "hefiltertypeid")
                      }
                    />
                  </div>
                  <div className="margin-right-8 width30">
                    <DynamicForm
                      fields={selectinputconverter({
                        value: hesubfiltertypeid && hesubfiltertypeid,
                        label: "",
                        options: subfilterTypes,
                        disabled: false,
                      })}
                      onChange={(val) =>
                        this.selectFilter(val, "hesubfiltertypeid")
                      }
                    />
                  </div>
                  {hesubfiltertypeid && hesubfiltertypeid != 1 && (
                    <div className="width30">
                      <DynamicForm
                        fields={multiselectinputconverter({
                          value: hesubfilterids,
                          label: "",
                          options:
                            hesubfiltertypeid == 2
                              ? this.props.businessUnits
                              : hesubfiltertypeid == 3
                              ? this.props.departmentList
                              : hesubfiltertypeid == 4
                              ? this.props.locationList
                              : [],
                          disabled: false,
                          idonly: true,
                        })}
                        onChange={(val) =>
                          this.selectFilter(val, "hesubfilterids")
                        }
                      />
                    </div>
                  )}
                </div>
              </Grid>
            </Grid>
            <div style={{ height: 250 }} className="line-data">
              <ResponsiveLineCanvas
                // width={700}
                height={250}
                enablePointLabel={false}
                pointLabel="y"
                pointLabelYOffset={-12}
                useMesh={true}
                enableGridX={true}
                colors={["#ff6c40", "#826af9"]}
                lineWidth={1}
                pointSize={4}
                data={this.state.hireexitdata}
                margin={{
                  top: 20,
                  right: 80,
                  bottom: 36,
                  left: 20,
                }}
                enableLabel={true}
                enableGridY={true}
                animate={true}
                motionStiffness={90}
                motionDamping={15}
                isInteractive={true}
                axisLeft={{
                  tickSize: 1,
                  tickPadding: 5,
                  tickRotation: 0,
                  legend: "%",
                  tickValues: 5,
                  legendPosition: "middle",
                  legendOffset: -20,
                }}
                axisBottom={{
                  tickSize: 1,
                  tickPadding: 5,
                  tickRotation: 0,
                  legend: "Month",
                  tickValues: 5,
                  legendPosition: "middle",
                  legendOffset: 30,
                }}
                legends={[
                  {
                    anchor: "bottom-right",
                    direction: "column",
                    justify: false,
                    translateX: 140,
                    translateY: 0,
                    itemsSpacing: 2,
                    itemDirection: "left-to-right",
                    itemWidth: 130,
                    itemHeight: 12,
                    itemOpacity: 0.75,
                    symbolSize: 9,
                    symbolShape: "circle",
                    effects: [
                      {
                        on: "hover",
                        style: {
                          itemOpacity: 1,
                        },
                      },
                    ],
                  },
                ]}
              />
            </div>
          </Paper>
        </Grid>
        <Grid container spacing={1}>
          <Grid item xs={12} md={4} sm={12}>
            <Paper className="padding16 margin-bottom-16 rounded-rectangle-paper">
              <div className="t-bold margin-bottom-8">Request statistics</div>
              <div className="width60">
                <DynamicForm
                  fields={selectinputconverter({
                    value: requestcounttype,
                    label: "",
                    options: requestCountTypes,
                    disabled: false,
                  })}
                  onChange={(val) => this.selectFilter(val, "requestcounttype")}
                />
              </div>
              <div className="margin-bottom-8">Request generated</div>
              <div className="margin-bottom-8" style={{ color: "#057cff" }}>
                {this.state.requestCountData[0]
                  ? this.state.requestCountData[0].totalrequestcount
                  : "0"}
              </div>
              <div style={{ height: 218 }}>
                <ResponsiveBarCanvas
                  layout="horizontal"
                  data={
                    this.state.requestCountData[0]
                      ? this.state.requestCountData[0].reqdata.map((x) => ({
                          Value: x.displayvalue,
                          displayname: x.displayname,
                        }))
                      : []
                  }
                  keys={["Value"]}
                  indexBy={"displayname"}
                  pixelRatio={1}
                  padding={0.8}
                  margin={{
                    top: 10,
                    right: 10,
                    bottom: 36,
                    left: 80,
                  }}
                  minValue="0"
                  maxValue={
                    Math.max(
                      ...(this.state.requestCountData[0]
                        ? this.state.requestCountData[0].reqdata.map(
                            (x) => x.displayvalue,
                          )
                        : []),
                    ) || "auto"
                  }
                  colors={["#0095ff"]}
                  enableLabel={true}
                  axisRight={null}
                  axisLeft={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: "Value",
                    legendPosition: "middle",
                    legendOffset: -90,
                  }}
                  axisBottom={{
                    tickSize: 1,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: "",
                    tickValues:
                      Math.max(
                        ...(this.state.requestCountData[0]
                          ? this.state.requestCountData[0].reqdata.map(
                              (x) => x.displayvalue,
                            )
                          : []),
                      ) > 2
                        ? 4
                        : 2,
                    legendPosition: "middle",
                    legendOffset: 30,
                  }}
                  enableGridX={true}
                  enableGridY={false}
                  animate={true}
                  motionStiffness={90}
                  motionDamping={15}
                  isInteractive={true}
                />
              </div>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={12} md={8}>
            <Paper className="padding16 margin-bottom-16 rounded-rectangle-paper">
              <Grid container spacing={1}>
                <Grid item xs={12} md={2} sm={12}>
                  <div className="t-bold margin-bottom-8">Attrition rate</div>
                </Grid>
                <Grid item xs={12} md={10} sm={12}>
                  <div
                    className="width100"
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <div className="margin-right-8 width30">
                      <DynamicForm
                        fields={selectinputconverter({
                          value: afiltertypeid,
                          label: "",
                          options: filterTypes,
                          disabled: false,
                        })}
                        onChange={(val) =>
                          this.selectFilter(val, "afiltertypeid")
                        }
                      />
                    </div>
                    <div className="margin-right-8 width30">
                      <DynamicForm
                        fields={selectinputconverter({
                          value: asubfiltertypeid,
                          label: "",
                          options: subfilterTypes,
                          disabled: false,
                        })}
                        onChange={(val) =>
                          this.selectFilter(val, "asubfiltertypeid")
                        }
                      />
                    </div>
                    {asubfiltertypeid && asubfiltertypeid != 1 && (
                      <div className="floatright width30">
                        <DynamicForm
                          fields={multiselectinputconverter({
                            value: asubfilterids,
                            label: "",
                            options:
                              asubfiltertypeid == 2
                                ? this.props.businessUnits
                                : asubfiltertypeid == 3
                                ? this.props.departmentList
                                : asubfiltertypeid == 4
                                ? this.props.locationList
                                : [],
                            disabled: false,
                            idonly: true,
                          })}
                          onChange={(val) =>
                            this.selectFilter(val, "asubfilterids")
                          }
                        />
                      </div>
                    )}
                  </div>
                </Grid>
              </Grid>
              <div style={{ height: 300 }} className="line-data">
                <ResponsiveLineCanvas
                  width={700}
                  height={300}
                  enablePointLabel={false}
                  pointLabel="y"
                  pointLabelYOffset={-12}
                  useMesh={true}
                  enableGridX={true}
                  colors={["#18aca7", "#ff6c40", "#826af9"]}
                  lineWidth={1}
                  pointSize={4}
                  data={this.state.attrition}
                  margin={{
                    top: 20,
                    right: 80,
                    bottom: 36,
                    left: 20,
                  }}
                  axisLeft={{
                    tickSize: 1,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: "%",
                    tickValues: 5,
                    legendPosition: "middle",
                    legendOffset: -20,
                  }}
                  axisBottom={{
                    tickSize: 1,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: "Month",
                    tickValues: 5,
                    legendPosition: "middle",
                    legendOffset: 30,
                  }}
                  enableLabel={true}
                  enableGridY={true}
                  animate={true}
                  motionStiffness={90}
                  motionDamping={15}
                  isInteractive={true}
                  legends={[
                    {
                      anchor: "bottom-right",
                      direction: "column",
                      justify: false,
                      translateX: 140,
                      translateY: 0,
                      itemsSpacing: 2,
                      itemDirection: "left-to-right",
                      itemWidth: 130,
                      itemHeight: 12,
                      itemOpacity: 0.75,
                      symbolSize: 9,
                      symbolShape: "circle",
                      effects: [
                        {
                          on: "hover",
                          style: {
                            itemOpacity: 1,
                          },
                        },
                      ],
                    },
                  ]}
                />
              </div>
            </Paper>
          </Grid>
        </Grid>
        <Grid container spacing={1}>
          {this.state.upcomingEvents.length > 0 && (
            <Grid item xs={12} md={4} sm={12}>
              <div className="margin-bottom-24">
                <LabelIcon
                  label="Celebration for the next 30 days"
                  img={celebration}
                />
                <Paper
                  className="padding16 thin-scroll rounded-rectangle-paper"
                  style={{
                    height: "200px",
                    position: "relative",
                    overflowY: "auto",
                  }}
                >
                  {this.state.upcomingEvents.length > 0 ? (
                    this.state.upcomingEvents.map((event) => (
                      <div style={{ padding: "8px 16px" }}>
                        <Grid
                          container
                          style={{ borderBottom: "1px solid #edf5fd" }}
                        >
                          <Grid item xs={12} md={1} sm={12}>
                            <p className="t-12 margin-top-2">
                              {event.birthday ? "🎁" : event.work ? "💻" : "❣"}
                            </p>
                          </Grid>
                          <Grid item xs={12} md={5} sm={12}>
                            <p className="small-dark-secondary">
                              {event.birthday
                                ? getFormattedDate(event.dob)
                                : event.work
                                ? getFormattedDate(event.doj)
                                : getFormattedDate(
                                    event.marriageanniversarydate,
                                  )}
                            </p>
                          </Grid>
                          <Grid item xs={12} md={6} sm={12}>
                            <p className="small-dark-secondary text-align-right">
                              {event.fullname}
                            </p>
                          </Grid>
                        </Grid>
                      </div>
                    ))
                  ) : (
                    <div
                      style={{
                        fontSize: 14,
                        textAlign: "center",
                        marginTop: 20,
                      }}
                    >
                      No Records Found
                    </div>
                  )}
                </Paper>
              </div>
            </Grid>
          )}
          <Grid
            item
            xs={12}
            md={4}
            sm={12}
            style={{ padding: "0px 12px 0px 12px" }}
          >
            <div>
              <LabelIcon label="Recent joiners in last week" img={user} />
              <Paper
                className="padding16 cursurpointer rounded-rectangle-paper"
                style={{
                  height: 42,
                }}
                onClick={this.openDrawer}
              >
                <div className="floatleft cursurpointer margin-top-8">
                  <p className="t-bold large-text-dark-secondary cursurpointer">
                    {this.state.joining ? this.state.joining : "0"} People
                  </p>
                </div>
                <div className="floatright cursurpointer margin-top-8">
                  <span style={{ fontSize: 26 }}>🙋🏻‍♂️</span>
                </div>
              </Paper>
            </div>
          </Grid>
          <Grid item xs={12} md={4} sm={12}>
            <div className="margin-bottom-24">
              <LabelIcon label="Expanding your team?" img={invite} />
              <Paper
                className="padding16 rounded-rectangle-paper"
                style={{
                  height: 42,
                  cursor: "pointer",
                }}
                onClick={this.openDilogGrid}
              >
                <div className="floatleft cursurpointer margin-top-8">
                  <p className="normal-blue-dark">Invite team member</p>
                </div>
                <div className="floatright cursurpointer margin-top-8">
                  <img
                    className="cursurpointer"
                    src={rightarrow}
                    style={{ fontSize: 26 }}
                  ></img>
                </div>
              </Paper>
            </div>
          </Grid>
          <Grid item xs={12} md={4} sm={12}>
            <ShareIdea openForm={this.props.openForm} />
          </Grid>
        </Grid>
        <Dialog
          fullWidth={true}
          maxWidth="sm"
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="max-width-dialog-title"
        >
          <DialogTitle
            id="max-width-dialog-title"
            className="large-text-dark t-bold"
          >
            Invite your team members
          </DialogTitle>
          <DialogContent>
            <div
              style={{
                height: "300px",
                width: "100%",
              }}
            >
              <div
                className="common-menubar-header"
                style={{ position: "unset" }}
              >
                <Tabs
                  value={value}
                  onChange={this.OnTabChange}
                  indicatorColor="#fff"
                  textColor="primary"
                >
                  <Tab
                    label="Invite via email"
                    className={`tabheading invite-label ${
                      this.state.value == 0 ? "active-tab1" : "inactive-tab1"
                    } `}
                  />
                  <Tab
                    label="Invite via SMS"
                    className={`tabheading invite-label ${
                      this.state.value == 1 ? "active-tab1" : "inactive-tab1"
                    } `}
                  />
                </Tabs>
                <div className="tab-border"></div>
              </div>
              {value === 0 && (
                <TabContainer>
                  {!invited0 ? (
                    <Grid
                      container
                      className="margin-top-24"
                      setTabValue={this.setTabValue}
                    >
                      {this.state.empdata.map((emp, index) => (
                        <Grid container>
                          <Grid
                            item
                            xs={12}
                            md={3}
                            sm={3}
                            style={{ paddingRight: 4, paddingBottom: 8 }}
                          >
                            <p className="input-label">Enter first name</p>
                            <TextField
                              className="formula-input"
                              variant="outlined"
                              placeholder="Enter name"
                              onChange={(e) =>
                                this.handleChange(
                                  "firstname",
                                  e.target.value,
                                  index,
                                )
                              }
                              value={emp.firstName}
                              maxLength="100"
                            />
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={3}
                            sm={3}
                            style={{ paddingLeft: 4, paddingBottom: 8 }}
                          >
                            <p className="input-label">Enter last name</p>
                            <TextField
                              className="formula-input"
                              variant="outlined"
                              placeholder="Enter name"
                              onChange={(e) =>
                                this.handleChange(
                                  "lastname",
                                  e.target.value,
                                  index,
                                )
                              }
                              value={emp.lastName}
                              maxLength="100"
                            />
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={6}
                            sm={6}
                            style={{ paddingLeft: 8, paddingBottom: 8 }}
                          >
                            <p className="input-label">Enter email address</p>
                            <TextField
                              className="formula-input"
                              variant="outlined"
                              type="email"
                              placeholder="Enter email address"
                              onBlur={(e) =>
                                this.validateEmail(e.target.value, index)
                              }
                              onChange={(e) =>
                                this.handleChange(
                                  "emailid",
                                  e.target.value,
                                  index,
                                )
                              }
                              value={emp.emailId}
                              maxLength="100"
                            />
                          </Grid>
                        </Grid>
                      ))}
                    </Grid>
                  ) : (
                    <Grid
                      container
                      style={{
                        position: "relative",
                        top: "50%",
                        transform: "translateY(30%)",
                        textAlign: "center",
                        height: 180,
                      }}
                    >
                      <Grid item xs={12} md={12} sm={12}>
                        <div className="margin-bottom-24">
                          <img src={check}></img>
                        </div>
                        <p className="large-text-dark">
                          You have successfully invited your team members.
                        </p>
                        <div style={{ textAlign: "center", marginTop: 24 }}>
                          <Button
                            className="btn btn-primary-md-blue"
                            variant="contained"
                            color="primary"
                            onClick={() => this.setState({ invited0: false })}
                          >
                            Invite more
                          </Button>
                        </div>
                      </Grid>
                    </Grid>
                  )}
                </TabContainer>
              )}
              {value === 1 && (
                <TabContainer>
                  {!invited1 ? (
                    <Grid
                      container
                      className="margin-top-24"
                      setTabValue={this.setTabValue}
                    >
                      {this.state.empdata.map((emp, index) => (
                        <Grid container>
                          <Grid
                            item
                            xs={12}
                            md={3}
                            sm={3}
                            style={{ paddingRight: 4, paddingBottom: 8 }}
                          >
                            <p className="input-label">Enter first name</p>
                            <TextField
                              className="formula-input"
                              variant="outlined"
                              placeholder="Enter name"
                              onChange={(e) =>
                                this.handleChange(
                                  "firstname",
                                  e.target.value,
                                  index,
                                )
                              }
                              value={emp.firstName}
                              maxLength="100"
                            />
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={3}
                            sm={3}
                            style={{ paddingLeft: 4, paddingBottom: 8 }}
                          >
                            <p className="input-label">Enter last name</p>
                            <TextField
                              className="formula-input"
                              variant="outlined"
                              placeholder="Enter name"
                              onChange={(e) =>
                                this.handleChange(
                                  "lastname",
                                  e.target.value,
                                  index,
                                )
                              }
                              value={emp.lastName}
                              maxLength="100"
                            />
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={6}
                            sm={6}
                            style={{ paddingLeft: 8, paddingBottom: 8 }}
                          >
                            <p className="input-label">Enter phone number</p>
                            <ReactPhoneInput
                              defaultCountry={"in"}
                              style={{ marginTop: 0 }}
                              className="margin-top-0"
                              onChange={(field, value) =>
                                this.OnPhoneChange(index, field, value)
                              }
                              countryCodeEditable={true}
                              value={emp.mobile}
                              InputProps={{ maxLength: 15, minLength: 5 }}
                            />
                          </Grid>
                        </Grid>
                      ))}
                    </Grid>
                  ) : (
                    <Grid
                      container
                      style={{
                        position: "relative",
                        top: "50%",
                        transform: "translateY(30%)",
                        textAlign: "center",
                        height: 180,
                      }}
                    >
                      <Grid item xs={12} md={12} sm={12}>
                        <div className="margin-bottom-24">
                          <img src={check}></img>
                        </div>
                        <p className="large-text-dark">
                          You have successfully invited your team members.
                        </p>
                        <div style={{ textAlign: "center", marginTop: 24 }}>
                          <Button
                            className="btn btn-primary-md-blue"
                            variant="contained"
                            color="primary"
                            onClick={() => this.setState({ invited1: false })}
                          >
                            Invite more
                          </Button>
                        </div>
                      </Grid>
                    </Grid>
                  )}
                </TabContainer>
              )}
            </div>
          </DialogContent>
          {this.state.value == 0 && !this.state.invited0 && (
            <DialogActions style={{ margin: 16 }}>
              <Button
                onClick={this.handleClose}
                className="btn btn-secondary-md-blue"
                color="primary"
              >
                Cancel
              </Button>
              <Button
                className="btn btn-primary-md-blue"
                variant="contained"
                color="primary"
                onClick={this.sendDetails}
              >
                Invite
              </Button>
            </DialogActions>
          )}
          {this.state.value == 1 && !this.state.invited1 && (
            <DialogActions style={{ margin: 16 }}>
              <Button
                onClick={this.handleClose}
                className="btn btn-secondary-md-blue"
                color="primary"
              >
                Cancel
              </Button>
              <Button
                className="btn btn-primary-md-blue"
                variant="contained"
                color="primary"
                onClick={this.sendDetails}
              >
                Invite
              </Button>
            </DialogActions>
          )}
          {this.state.value == 0 && this.state.invited0 && (
            <DialogActions style={{ margin: 16 }}></DialogActions>
          )}
          {this.state.value == 1 && this.state.invited1 && (
            <DialogActions style={{ margin: 16 }}></DialogActions>
          )}
        </Dialog>
        <Drawer
          anchor="right"
          open={this.state.DrawerOpen}
          onClose={this.handleClickAway}
          style={{ padding: 40 }}
          classes={{
            paper: "planner-drawer width30 padding15",
          }}
        >
          <DrawerHeader
            header="Recent joiners in last 7 days"
            isbackarrow={false}
            closeDrawer={this.handleClickAway}
          />
          {this.state.recentJoinees.map((emp) => (
            <div>
              <div className="position-rel">
                <div className="width100">
                  <div className="floatleft">
                    <img
                      src={getFormattedImageLink(emp.imagepath)}
                      className="dir-profile-img margin-top-3"
                      height="83"
                    ></img>
                  </div>
                  <div className="floatleft margin-top-16 margin-left-16">
                    <p className="small-dark-secondary t-bold">
                      {emp.fullname}
                    </p>
                    <p className="extra-small-dark-disabled">
                      {emp.designationname}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
          {this.state.recentJoinees.length == 0 && (
            <div
              style={{ height: "77vh" }}
              className="position-rel margin-top-16"
            >
              <DefaultComp
                heading={"No recent joinees in last 7 days"}
                imageSrc={defaultstateimg}
              />
            </div>
          )}
        </Drawer>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => ({
  subscription: state.SubscriptionInfo.SubscriptionData,
  AuthenticationAction: state.AuthenticationAction,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withSnackbar(Hris));
